var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9996 -2.779398e-02 2.779398e-02 0.9996 -3.5082 3.6071)",
    className: "st0",
    cx: 128,
    cy: 128,
    rx: 117.5,
    ry: 117.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.5,79.4c-7.5,2.5-16.8,2.9-20.5,3c-3.7-0.1-13-0.5-20.5-3c-14.3-4.8-37.3-7.8-54.8-7.4 c-13,0.3-26.4,2.1-34.8,3.7c-3.7,0.8-6.1,4.4-5.2,8.1l0.9,3.8c0.5,2.2,2.3,3.9,4.4,4.7c1.1,0.4,2.2,1.1,2.7,2.4 c1.5,4,9.6,28,14,36.9c3.6,7.3,13.4,13.5,36.1,13.6c32.3,0.1,43.5-21.2,48.7-35.1c0.5-1.4,1.4-4.2,2.1-6.9 c1.1-3.8,3.4-7.6,4.4-8.2c0.6-0.3,1.3-0.6,2-0.6c0.7,0,1.4,0.3,2.1,0.6c1,0.5,3.3,4.3,4.4,8.2c0.7,2.7,1.5,5.4,2.1,6.9 c5.1,13.8,16.3,35.2,48.7,35.1c22.7-0.1,32.5-6.3,36.1-13.6c4.4-8.9,12.5-32.9,14-36.9c0.5-1.3,1.6-2,2.7-2.4 c2.2-0.8,3.9-2.4,4.4-4.7l0.9-3.8c0.9-3.7-1.5-7.3-5.2-8.1c-8.4-1.7-21.8-3.4-34.8-3.7C185.8,71.7,162.8,74.7,148.5,79.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.1,188.1c-3.1,0-6.3-0.2-9.5-0.7c-3.1-0.5-5.3-3.4-4.8-6.5c0.5-3.1,3.4-5.3,6.5-4.8 c18.2,2.7,34.3-4.1,41.2-17.5c1.4-2.8,4.9-3.9,7.7-2.5c2.8,1.4,4,4.9,2.5,7.7C188.8,179.1,172.3,188.1,153.1,188.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProud);
export default __webpack_public_path__ + "static/media/Proud.c6acbe11fbf7efee5a6e2677ff445a5a.svg";
export { ForwardRef as ReactComponent };